import React from 'react'
import { styled } from '~/app/components'
import { Typography } from '@yanolja-org/ya-com-core'

/**
 * ThemeIcon component
 * author: soojin.oh
 * $description$
 */

// type definitions
type ThemeIconProps = {
  src: string
  description: string
}

// styled components
const Container = styled.div`
  display: inline-block;
  height: 7.9rem;
  width: 5.6rem;
  margin-right: 3.2rem;
`
const Icon = styled.img`
  width: 5.6rem;
  height: 4rem;
  margin-bottom: 1.2rem;
`
const Description = styled.div`
  ${Typography('body2').bold};
  text-align: center;
  white-space: nowrap;
  color: ${({ theme }) => theme.color.gray600};
`

// ThemeIcon component
const ThemeIcon: React.FunctionComponent<ThemeIconProps> = function ({ src, description }) {
  return (
    <Container>
      <Icon src={src} alt={description} />
      <Description>{description}</Description>
    </Container>
  )
}

export default ThemeIcon
